import { createStructuredSelector } from 'reselect'

import {
  SEARCH_GEO_COUNTRY,
  SEARCH_GEO_COUNTRY_SUCCESS,
  SEARCH_GEO_COUNTRY_ERROR,
  SEARCH_SUPPLIER_STATE,
  SEARCH_SUPPLIER_STATE_SUCCESS,
  SEARCH_SUPPLIER_STATE_ERROR
} from '../actions';

export const NAME = 'search';


export const SearchGeoCountry = () => ({
  type: SEARCH_GEO_COUNTRY
});

export const SearchGeoCountrySuccess = (data) => ({
  type: SEARCH_GEO_COUNTRY_SUCCESS,
  payload: data
});

export const SearchGeoCountryError = (error) => ({
  type: SEARCH_GEO_COUNTRY_ERROR,
  payload: error
});

export const SearchSupplierState = () => ({
  type: SEARCH_SUPPLIER_STATE
});

export const SearchSupplierStateSuccess = (data) => ({
  type: SEARCH_SUPPLIER_STATE_SUCCESS,
  payload: data
});

export const SearchSupplierStateError = (error) => ({
  type: SEARCH_SUPPLIER_STATE_ERROR,
  payload: error
});

const search = (state) => state[NAME];

export const SearchSelector = createStructuredSelector({
  search
})
